import styled from 'styled-components';

export const LabelsMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;
